import styled from 'styled-components';
import {Row, RowW50Styles, Column} from '../../common/Layouts/Layouts';

export const RoomTypeLoaderWrapDiv = styled.div(
  props => `

  display:flex;
  flex-direction: column;
  max-width: 120rem;
  // margin: 0 auto;
  width:100%;
  background-color:${props.theme.colors.goWhite.base};
  border-radius:${props.theme.misc.borderRadius.large};
  // margin-top:${props.theme.spacing.xlarge};
  // border-radius: ${props.theme.misc.borderRadius.base};
  margin: ${props.theme.spacing.xlarge} auto 0 auto;

`,
);

export const RoomTypeLoaderInnerWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  max-width: 120rem;
  width:20%;
  background-color:${props.theme.colors.goWhite.base};
  border-radius:${props.theme.misc.borderRadius.large};

`,
);

export const RoomTypeLoaderContentWrapDiv = styled.div(
  props => `

  display:flex;

`,
);

export const RoomTypeLoaderContentLeftDiv = styled.div(
  props => `
  width: 25%;
  border-right: 1px solid #dcddde;
  padding: ${props.theme.spacing.large} ${props.theme.spacing.custom(32)};

`,
);

export const RoomTypeLoaderContentRightDiv = styled.div(
  props => `

  display:flex;
  width:75%;
  border-bottom: 5px solid #dcddde;

`,
);

export const RoomTypeLoaderHeaderDiv = styled.div(
  props => `

  padding: ${props.theme.spacing.small} ${props.theme.spacing.custom(8)};
  width:25%;
  font-weight: 600;

`,
);

export const RoomTypeLoaderOptionsDiv = styled.div(
  props => `

  border-right: 1px solid #dcddde;
  padding: ${props.theme.spacing.custom(24)} ${props.theme.spacing.custom(22)};
  width:36%;

`,
);

export const RoomTypeLoaderOptionsTextDiv = styled.div(
  props => `

  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};
  width:16.3rem;
  height:1.8rem;

`,
);

export const RoomTypeLoaderOptionsTextLargeDiv = styled.div(
  props => `

  background-color:${props.theme.colors.goBrandBlue.medium};
  width:22.2rem;
  height:2.5rem;
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.xlarge};

`,
);

export const RoomTypeLoaderHeaderWrapDiv = styled.div(
  props => `

  display:flex;
  padding:${props.theme.spacing.custom(15)} ${props.theme.spacing.custom(25)};
  background-color:${props.theme.colors.goBrandBlue.medium};

`,
);

export const RoomTypeLoaderTypeTextDiv = styled.div(
  props => `

  background-color:${props.theme.colors.goBrandBlue.medium};
  width:16.3rem;
  height:1.6rem;
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};;
`,
);

export const RoomTypeLoaderImgDiv = styled.div(
  props => `

  background-color:${props.theme.colors.goBrandBlue.medium};
  width:20.5rem;
  height:13.9rem;
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};;

`,
);

export const RoomTypeLoaderDescpDiv = styled.div(
  props => `

  background-color:${props.theme.colors.goBrandBlue.medium};
  width:21.6rem;
  height:3.8rem;
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-top:${props.theme.spacing.custom(30)};

`,
);

export const RoomTypeLoaderInclusionsDiv = styled.div(
  props => `

  border-right: 1px solid #dcddde;
  padding: ${props.theme.spacing.custom(30)} ${props.theme.spacing.custom(22)};
  width: 36%;

`,
);

export const RoomTypeLoaderInclusionsTextDiv = styled.div(
  props => `

  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};
  width:19.8rem;
  height:1.8rem;

`,
);

export const RoomTypeLoaderPriceDescpDiv = styled.div(
  props => `

  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-top:${props.theme.spacing.custom(50)} ;
  margin-bottom:${props.theme.spacing.base};
  width:17.4rem;
  height:4.4rem;

`,
);

export const RoomTypeLoaderPriceDiv = styled.div(
  props => `

  padding: ${props.theme.spacing.custom(24)} ${props.theme.spacing.custom(22)};;
  width: 30rem;

`,
);

export const RoomTypeLoaderPricesTextDiv = styled.div(
  props => `

  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};
  width:17.5rem;
  height:2.3rem;

`,
);

export const RoomTypeLoaderPricesSmallTextDiv = styled.div(
  props => `

  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};
  width:12.1rem;
  height:1.8rem;

`,
);

export const RoomTypeLoaderPricesSmallerTextDiv = styled.div(
  props => `

  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};
  width:12.1rem;
  height:1.4rem;

`,
);

export const RoomTypeLoaderPriceLargeTextDiv = styled.div(
  props => `

  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};
  width:15.7rem;
  height:1.8rem;

`,
);
